import React, { createContext, useState, useContext, useCallback } from "react";
import { Alert, Snackbar } from "@mui/material";

// Create a Context
const AlertContext = createContext();

// Custom hook to use AlertContext
export const useAlert = () => useContext(AlertContext);

// Provider Component
export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState(null);

  // Function to trigger an alert
  const showAlert = useCallback((message, severity = "info") => {
    setAlert({ message, severity, id: Date.now() });
  }, []);

  // Function to hide the alert
  const hideAlert = useCallback(() => {
    setAlert(null);
  }, []);

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      {alert && (
        <Snackbar
          key={alert.id}
          open={!!alert}
          autoHideDuration={6000}
          onClose={hideAlert}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={hideAlert}
            severity={alert.severity}
            sx={{
              width: "100%",
              ...(alert.severity === "error" && { backgroundColor: "red", color: "white" }),
              ...(alert.severity === "success" && { backgroundColor: "green", color: "white" }),
            }}
          >
            {alert.message}
          </Alert>
        </Snackbar>
      )}
    </AlertContext.Provider>
  );
};
